export interface CompanyResponseModel {
  city: string;
  communicationLanguage: string;
  companyNumber: string;
  country: string;
  countryCode: string;
  email: string;
  id: string;
  latitude: number;
  longtitude: number;
  maxPrioContacts: number;
  multichannel: MultichannelNames;
  name: string;
  postalCode: string;
  primarySalesOrganizationData: string;
  prioContacts: number;
  salesOrg: string;
  street: string;
  salesOrganizationData: {
    Id: string;
    ExtSapVKDistrict: string;
    ExtSapVKGroup: string;
    ExtSapVKOffice: string;
    ExtSapVKOrg: string;
    PartnerClassification: string;
  }[];
}

export enum MultichannelNames {
  Installer = '1',
  ElectriciansAndSolateurs = '2',
  Wholesaler = '3',
  ForwardIntegratorsAndOnlinePlatforms = '4',
  Utilities = '5', // commercial
  DirectCommercialBusiness = '6',
  PrefabricatedHouses = '7',
  HousingSocieties = '8', // commercial
  BuySellReps = '9',
  ServiceCompanies = '10',
  DirectToConsumer = '11',
}
